'use strict';

var _defineProperty = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('interface-datastore'),
    Key = _require.Key,
    Errors = _require.Errors,
    utils = _require.utils;

var filter = utils.filter,
    map = utils.map,
    take = utils.take,
    sortAll = utils.sortAll;
/**
 * A datastore backed by leveldb.
 */

var LevelDatastore = /*#__PURE__*/function () {
  function LevelDatastore(path, opts) {
    _classCallCheck(this, LevelDatastore);

    var database;

    if (opts && opts.db) {
      database = opts.db;
      delete opts.db;
    } else {
      database = require('level');
    }

    this.db = database(path, _objectSpread(_objectSpread({}, opts), {}, {
      valueEncoding: 'binary',
      compression: false // same default as go

    }));
  }

  _createClass(LevelDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.db.open();

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                throw Errors.dbOpenFailedError(_context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.db.put(key.toString(), value);

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                throw Errors.dbWriteFailedError(_context2.t0);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.db.get(key.toString());

              case 3:
                data = _context3.sent;
                _context3.next = 11;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);

                if (!_context3.t0.notFound) {
                  _context3.next = 10;
                  break;
                }

                throw Errors.notFoundError(_context3.t0);

              case 10:
                throw Errors.dbWriteFailedError(_context3.t0);

              case 11:
                return _context3.abrupt("return", data);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "has",
    value: function () {
      var _has = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.db.get(key.toString());

              case 3:
                _context4.next = 10;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);

                if (!_context4.t0.notFound) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", false);

              case 9:
                throw _context4.t0;

              case 10:
                return _context4.abrupt("return", true);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function has(_x4) {
        return _has.apply(this, arguments);
      }

      return has;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.db.del(key.toString());

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);
                throw Errors.dbDeleteFailedError(_context5.t0);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "close",
    value: function close() {
      return this.db.close();
    }
  }, {
    key: "batch",
    value: function batch() {
      var _this = this;

      var ops = [];
      return {
        put: function put(key, value) {
          ops.push({
            type: 'put',
            key: key.toString(),
            value: value
          });
        },
        delete: function _delete(key) {
          ops.push({
            type: 'del',
            key: key.toString()
          });
        },
        commit: function commit() {
          return _this.db.batch(ops);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q) {
      var values = true;

      if (q.keysOnly != null) {
        values = !q.keysOnly;
      }

      var it = levelIteratorToIterator(this.db.db.iterator({
        keys: true,
        values: values,
        keyAsBuffer: true
      }));
      it = map(it, function (_ref) {
        var key = _ref.key,
            value = _ref.value;
        var res = {
          key: new Key(key, false)
        };

        if (values) {
          res.value = Buffer.from(value);
        }

        return res;
      });

      if (q.prefix != null) {
        it = filter(it, function (e) {
          return e.key.toString().startsWith(q.prefix);
        });
      }

      if (Array.isArray(q.filters)) {
        it = q.filters.reduce(function (it, f) {
          return filter(it, f);
        }, it);
      }

      if (Array.isArray(q.orders)) {
        it = q.orders.reduce(function (it, f) {
          return sortAll(it, f);
        }, it);
      }

      if (q.offset != null) {
        var i = 0;
        it = filter(it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) {
        it = take(it, q.limit);
      }

      return it;
    }
  }]);

  return LevelDatastore;
}();

function levelIteratorToIterator(li) {
  return _defineProperty({
    next: function next() {
      return new Promise(function (resolve, reject) {
        li.next(function (err, key, value) {
          if (err) return reject(err);
          if (key == null) return resolve({
            done: true
          });
          resolve({
            done: false,
            value: {
              key: key,
              value: value
            }
          });
        });
      });
    },
    return: function _return() {
      return new Promise(function (resolve, reject) {
        li.end(function (err) {
          if (err) return reject(err);
          resolve({
            done: true
          });
        });
      });
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
}

module.exports = LevelDatastore;